import { useEffect, useState } from "react";
import api from "@/lib/api";

export function usePublicBranding() {
  const [branding, setBranding] = useState({ app_name: "Maan group", logo_data_url: null });
  useEffect(() => {
    (async () => {
      try {
        const { data } = await api.get("/branding");
        setBranding(data);
      } catch (e) {
        console.error("Failed to fetch branding:", e);
      }
    })();
  }, []);
  return branding;
}
